import axios from "axios";

export default {
  //New functions should ALWAYS come on top here for easy updates

  //last compare and update below.
  postData(url, obj) {
    return axios
      .post(url, obj)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return error.response;
      });
  },

  getData(url, token) {
    return axios
      .get(url, { headers: { Authorization: "Bearer " + token } })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return error.response;
      });
  },

  postDataWithToken(url, paramsObj, token) {
    return axios
      .post(url, paramsObj, { headers: { Authorization: "Bearer " + token } })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return error.response;
      });
  },
  getCurrentDate() {
    const d = new Date();
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },

  generateToken() {
    return (+[1e7] + -1e3 + -4e3 + -8e3 + -1e11)
      .toString()
      .replace(/[018]/g, (c) =>
        (
          Number(c) ^
          (crypto.getRandomValues(new Uint8Array(1))[0] &
            (15 >> (Number(c) / 4)))
        ).toString(16)
      );
    // return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    //     const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    //     return v.toString(16);
    // });
  },

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      const i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      const j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - Number(i))
              .toFixed(decimalCount)
              .slice(2)
          : "")
      );
    } catch (e) {
      const v = e;
      return v;
    }
  },
};
